import { SourcingOpenings } from 'api-clients/monolith';

import { useEditTargetsContext } from '@/contexts/edit-targets-context';
import { useHireUrl } from '@/hooks/use-hire-url';

export function useEditTargets() {
  const { openEditTargetsDialog, setHiringGoal, setHiringGoalUrl } =
    useEditTargetsContext();
  const { getHireATHiringGoalUrl } = useHireUrl();

  const handleEditTargets = (rowItem: SourcingOpenings) => {
    setHiringGoalUrl(
      getHireATHiringGoalUrl(
        rowItem.brand_slug ?? 'no_brand',
        rowItem.location_id,
        rowItem.external_id,
      ),
    );

    if (!rowItem.hiring_goal) {
      setHiringGoal(undefined);
      openEditTargetsDialog();
      return;
    }

    setHiringGoal({
      openingSlug: rowItem.slug,
      openingName: rowItem.title,
      startDate: rowItem.hiring_goal.start_date ?? '',
      endDate: rowItem.hiring_goal.hire_by ?? '',
      goal: rowItem.hiring_goal.goal,
      duration: rowItem.hiring_goal.duration,
    });
    openEditTargetsDialog({
      targets: {
        conversion: rowItem.conversion_stats.expected,
        budget: rowItem.budget_stats.expected,
        cpa: rowItem.cpa_stats.expected,
      },
    });
  };

  return { handleEditTargets };
}
